import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Lock, Settings, BarChart3, TrendingUp, ScrollText, Quote, Rocket, CalendarDays, Crown } from 'lucide-react';
import { UrgencyBar } from '../components/UrgencyBar';
import { FAQ } from '../components/FAQ';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function Registro() {
  // Meta Pixel
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  // Load GoHighLevel script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://api.leadconnectorhq.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const scrollToForm = () => {
    const formElement = document.getElementById('registro-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="min-h-screen bg-white font-sans text-dark" data-id="element-69">
      <UrgencyBar data-id="element-70" />

      {/* HERO SECTION - ABOVE THE FOLD */}
      <section className="relative pt-4 pb-8 px-4 md:pt-12 md:pb-20 overflow-hidden" data-id="element-71">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/2WejS4g1gDYkEogUGNfpCe/susana_sanchez_mentor.png)'
      }} data-id="element-72" />
        <div className="absolute inset-0 bg-dark/80" data-id="element-73" />
        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start" data-id="element-74">
          {/* MOBILE: Title first, form second. DESKTOP: Form is on the right */}
          <div className="order-2 lg:order-2 w-full max-w-md mx-auto lg:max-w-none" id="registro-form" data-id="element-75">
            <div className="bg-white p-4 md:p-6 rounded-2xl shadow-xl border-t-4 border-gold-metallic" data-id="element-76">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-77">
                <Crown className="w-5 h-5 text-gold-metallic" data-id="element-78" />
                <h3 className="text-lg md:text-xl font-bold text-center text-dark" data-id="element-79">
                  Reserva tu lugar ahora
                </h3>
              </div>
              {/* GoHighLevel Form Widget */}
              <div className="w-full" data-id="element-80">
                <iframe src="https://api.leadconnectorhq.com/widget/form/aGRSBlVwchDixedJn3DU" style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '4px',
                minHeight: '220px'
              }} id="inline-aGRSBlVwchDixedJn3DU" data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name="Webinar Registration" data-height="220" data-layout-iframe-id="inline-aGRSBlVwchDixedJn3DU" data-form-id="aGRSBlVwchDixedJn3DU" title="Webinar Registration" data-id="element-81" />
              </div>
              <div className="mt-1 text-center" data-id="element-82">
                <span className="inline-block bg-gold-light text-gold-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide mb-1" data-id="element-83">
                  Acceso Exclusivo Gratuito
                </span>
                <p className="text-xs text-gray-500" data-id="element-84">
                  Registro sin costo. Cupo limitado para asegurar la calidad de
                  la sesión.
                </p>
              </div>
            </div>
          </div>

          {/* LEFT CONTENT */}
          <div className="order-1 lg:order-1 flex flex-col justify-center h-full" data-id="element-85">
            <motion.div initial="hidden" animate="visible" variants={fadeInUp} data-id="element-86">
              <div className="inline-flex items-center gap-2 bg-white px-3 py-1.5 rounded-full shadow-sm mb-3 md:mb-6 border border-gold/30" data-id="element-87">
                <CalendarDays className="w-4 h-4 md:w-5 md:h-5 text-gold-metallic" data-id="element-88" />
                <span className="font-semibold text-xs md:text-sm text-gold-dark uppercase tracking-wider" data-id="element-89">
                  Webinar gratuito: 16 de abril, 2026 — 7pm (Hora CDMX)
                </span>
              </div>

              <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 lg:mb-6 text-white" data-id="element-90">
                La Nueva{' '}
                <span className="text-gold-metallic" data-id="element-91">Regla de Oro</span> del
                Inversionista:{' '}
                <span className="text-white" style={{
                backgroundImage: 'linear-gradient(transparent 60%, #E91E90 60%)',
                boxDecorationBreak: 'clone',
                WebkitBoxDecorationBreak: 'clone' as any
              }} data-id="element-92">
                  Cómo Ser Dueño de un Terreno
                </span>{' '}
                que te Pague una Renta Vitalicia por 20 Años
              </h1>

              {/* Desktop only: show paragraph here */}
              <p className="hidden lg:block text-lg lg:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-93">
                <strong className="text-white" data-id="element-94">Susana Sanchez G</strong> revela
                el sistema de "Coparticipación de Cosecha": Una oportunidad de
                inversión patrimonial donde el terreno es tuyo, los expertos
                operan por ti y tú solo recibes las utilidades anuales
                certificadas.
              </p>
            </motion.div>
          </div>

          {/* Mobile only: paragraph after form */}
          <div className="order-3 lg:hidden" data-id="element-95">
            <p className="text-base text-gray-300 leading-relaxed" data-id="element-96">
              <strong className="text-white" data-id="element-97">Susana Sanchez G</strong> revela el
              sistema de "Coparticipación de Cosecha": Una oportunidad de
              inversión patrimonial donde el terreno es tuyo, los expertos
              operan por ti y tú solo recibes las utilidades anuales
              certificadas.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 1: EL GANCHO */}
      <section className="py-20 bg-dark text-white px-4" data-id="element-98">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeInUp} className="max-w-4xl mx-auto text-center" data-id="element-99">
          <div className="w-16 h-16 bg-gold-metallic/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-100">
            <Lock className="w-8 h-8 text-gold-light" data-id="element-101" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2" data-id="element-102">
            La Trampa del Sueldo y del Profesional Independiente
          </h2>
          <div className="w-16 h-1 bg-gold-metallic mx-auto mb-8 rounded-full" data-id="element-103"></div>
          <div className="space-y-6 text-lg text-gray-300 leading-relaxed text-left md:text-center" data-id="element-104">
            <p data-id="element-105">
              Muchos profesionales o Profesionales Independientes están
              atrapados en una "jaula de oro": tienen buenos ingresos, pero si
              dejan de trabajar hoy, el flujo se detiene mañana. Depender de una
              sola fuente de ingresos —o de una jubilación estatal insuficiente—
              es el mayor riesgo financiero de 2026.
            </p>
            <p data-id="element-106">
              La verdadera libertad no es tener un gran ahorro en el banco que
              la inflación devora cada mes; la verdadera libertad es poseer{' '}
              <strong className="text-gold-light" data-id="element-107">
                Sistemas de Producción
              </strong>
              . Este 16 de abril a las 7pm (Hora CDMX), en mi Webinar gratuito,
              te enseñaré cómo adquirir una "unidad de negocio" física que
              genera dividendos constantes, permitiéndote construir un sueldo
              paralelo que no dependa de tu tiempo.
            </p>
          </div>
        </motion.div>
      </section>

      {/* SECCIÓN 2: LA TESIS DE INVERSIÓN */}
      <section className="py-24 bg-lightgray px-4" data-id="element-108">
        <div className="max-w-7xl mx-auto" data-id="element-109">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center mb-16" data-id="element-110">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2 text-dark" data-id="element-111">
              Lo que descubrirás en este entrenamiento
            </h2>
            <div className="w-16 h-1 bg-gold-metallic mx-auto mb-4 rounded-full" data-id="element-112"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-113">
              Susana Sanchez G desglosará el modelo que los inversionistas
              inmobiliarios tradicionales están ignorando:
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-114">
            {[{
            icon: <Settings className="w-8 h-8 text-gold-metallic" data-id="element-115" />,
            title: 'Infraestructura de Activos Reales',
            desc: "Cómo pasar de comprar 'lotes baldíos' a ser dueño de parcelas productivas con título de propiedad."
          }, {
            icon: <BarChart3 className="w-8 h-8 text-gold-metallic" data-id="element-116" />,
            title: "Ingresos de 'Manos Libres'",
            desc: 'El esquema de operación donde tú pones el capital y un equipo agrícola experto con 35 años de experiencia pone el trabajo, la tecnología y la logística de exportación.'
          }, {
            icon: <TrendingUp className="w-8 h-8 text-gold-metallic" data-id="element-117" />,
            title: 'ROI Compuesto',
            desc: 'Cómo el flujo de caja de la cosecha (Rentas anuales) combinado con la plusvalía de la tierra genera un rendimiento superior a cualquier renta tradicional.'
          }, {
            icon: <ScrollText className="w-8 h-8 text-gold-metallic" data-id="element-118" />,
            title: 'Certeza Jurídica de Grado Inversionista',
            desc: 'El marco legal (Escrituras ante Notario y Contratos de Explotación) que protege tu inversión por las próximas dos décadas.'
          }].map((item, idx) => <motion.div key={idx} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={{
            hidden: {
              opacity: 0,
              y: 20
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                delay: idx * 0.1
              }
            }
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-gold/20 hover:shadow-md hover:border-gold/40 transition-all" data-id="element-119">
                <div className="w-14 h-14 bg-gold-light rounded-xl flex items-center justify-center mb-6" data-id="element-120">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-dark" data-id="element-121">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-122">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 3: PERFIL DE LA ESTRATEGA */}
      <section className="py-24 bg-white px-4" data-id="element-123">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-125">
            <div className="absolute inset-0 bg-gradient-to-br from-gold-metallic to-gold rounded-3xl transform -rotate-3 scale-105 opacity-20" data-id="element-126"></div>
            <img src="https://cdn.magicpatterns.com/uploads/4zCA77ccagR9m3aBdgwRMG/Estratega_Susana_Sanchez.jpg" alt="Susana Sanchez G" className="relative z-10 w-full rounded-3xl shadow-xl object-cover aspect-[4/5] ring-4 ring-gold-metallic/30" data-id="element-127" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-128">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6 text-dark" data-id="element-129">
              Conoce a tu Mentora
            </h2>
            <div className="mb-8 relative bg-gradient-to-r from-gold-light/50 to-transparent p-6 rounded-xl" data-id="element-130">
              <Quote className="absolute top-2 left-2 w-10 h-10 text-gold-metallic/30" data-id="element-131" />
              <p className="text-2xl font-heading italic text-gold-dark relative z-10 pl-4 border-l-4 border-gold-metallic" data-id="element-132">
                "Mi objetivo es que tu capital sea el que trabaje horas extra,
                no tú."
              </p>
            </div>
            <div className="space-y-4 text-lg text-gray-600 leading-relaxed" data-id="element-133">
              <p data-id="element-134">
                <strong data-id="element-135">Susana Sanchez G</strong> es especialista en Bienes
                Raíces e Inversiones de Flujo.
              </p>
              <p data-id="element-136">
                Se dedica a auditar y seleccionar vehículos financieros que
                ofrezcan el equilibrio perfecto entre Seguridad Patrimonial y
                Maximización de Dividendos.
              </p>
              <p data-id="element-137">
                Es la arquitecta detrás de cientos de estrategias de jubilación
                anticipada en Latinoamérica.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECCIÓN 4: TESTIMONIO */}
      <section className="py-20 bg-agri text-white px-4" data-id="element-138">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-4xl mx-auto text-center" data-id="element-139">
          <Quote className="w-12 h-12 text-gold-metallic mx-auto mb-8" data-id="element-140" />
          <p className="text-2xl md:text-3xl font-heading font-medium leading-relaxed mb-8" data-id="element-141">
            "Analicé FIBRAS y departamentos, pero los números del Crowdfarming
            con Susana superaron todo. Es un activo real que diversifica mi
            portafolio y me da flujo anual sin tener que lidiar con inquilinos o
            reparaciones de edificios."
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-142">
            <div className="w-12 h-12 bg-gold-metallic/30 rounded-full flex items-center justify-center font-bold text-xl text-gold-light" data-id="element-143">
              A
            </div>
            <div className="text-left" data-id="element-144">
              <p className="font-bold text-lg" data-id="element-145">Ing. Alberto D.</p>
              <p className="text-white/70 text-sm" data-id="element-146">
                Director de Operaciones e Inversionista
              </p>
            </div>
          </div>
        </motion.div>
      </section>

      {/* SECCIÓN 5: EL CIERRE (CTA) */}
      <section className="py-24 bg-pitahaya-light px-4 text-center" data-id="element-147">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeInUp} className="max-w-3xl mx-auto" data-id="element-148">
          <Crown className="w-10 h-10 text-gold-metallic mx-auto mb-4" data-id="element-149" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2 text-dark" data-id="element-150">
            Asegura tu lugar en este evento exclusivo
          </h2>
          <div className="w-16 h-1 bg-gold-metallic mx-auto mb-10 rounded-full" data-id="element-151"></div>

          <div className="bg-white rounded-2xl p-8 shadow-lg mb-10 border border-gold/20 text-left" data-id="element-152">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-153">
              <div data-id="element-154">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-155">
                  Cuándo
                </p>
                <p className="font-semibold text-lg" data-id="element-156">
                  16 de Abril, 2026 — 7pm (Hora CDMX)
                </p>
              </div>
              <div data-id="element-157">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-158">
                  Para Quién
                </p>
                <p className="font-semibold" data-id="element-159">
                  Personas interesadas en hacer crecer su capital con activos de
                  flujo.
                </p>
              </div>
              <div data-id="element-160">
                <p className="text-sm text-gold-dark font-bold uppercase tracking-wider mb-1" data-id="element-161">
                  Acceso Inmediato
                </p>
                <p className="font-semibold" data-id="element-162">
                  Al registrarte, podrás ingresar al Grupo Exclusivo de
                  WhatsApp.
                </p>
              </div>
            </div>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={scrollToForm} className="w-full md:w-auto bg-gradient-to-r from-pitahaya to-pitahaya-dark text-white font-bold py-5 px-8 rounded-xl shadow-xl hover:shadow-2xl transition-all flex items-center justify-center gap-3 text-lg md:text-xl mx-auto ring-2 ring-gold-metallic/40 ring-offset-2" data-id="element-163">
            <Rocket className="w-6 h-6" data-id="element-164" />
            ¡QUIERO MI ACCESO AL WEBINAR GRATUITO Y DISEÑAR MI RENTA VITALICIA!
          </motion.button>
          <p className="mt-4 text-sm text-gray-600" data-id="element-165">
            Registro sin costo. Cupo limitado para asegurar la calidad de la
            sesión.
          </p>
        </motion.div>
      </section>

      {/* SECCIÓN 6: FAQ */}
      <section className="py-20 bg-white px-4" data-id="element-166">
        <div className="max-w-3xl mx-auto" data-id="element-167">
          <h2 className="font-heading text-3xl font-bold mb-10 text-center text-dark" data-id="element-168">
            Preguntas Frecuentes
          </h2>
          <FAQ question="¿Se requiere de mi tiempo para la operación?" answer="Absolutamente no. Este sistema está diseñado para el ejecutivo ocupado; tú eres el dueño legal, pero la gestión agrícola y comercial es 100% delegada." data-id="element-169" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-dark text-white/60 py-8 text-center text-sm" data-id="element-170">
        <p data-id="element-171">&copy; 2026 Susana Sanchez G. Todos los derechos reservados.</p>
      </footer>
    </div>;
}